import React, { Component } from 'react';
import * as d3 from 'd3';
import "./speciesavatar.css";


class SpeciesAvatar extends Component {
  constructor(props){
      super(props);
      //this.allVillagers = this.props.villagers;
   }
  render() {
    //let getVillagerAvatar = this.props.villagers.find(v => v.species == this.props.species);
    //console.log(process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`;

    let species = this.props.species;

    let labelImg = (species  === 'Cow' || species === 'Bull')?'Bovine':species;

    labelImg = (labelImg.indexOf(' ') >= 0)?labelImg.replace(/ /g,"-"):labelImg;

    return (
      <span className="avatar species-avatar">
          <img src={process.env.PUBLIC_URL + `/images/species/${labelImg}.png`} alt="Avatar" />
          <b className="avatar-label">{species}</b>
      </span>

    )
  }
}

export default SpeciesAvatar;
